/**
 * GetSubscriptionInfoQuery - Fetches current user's subscription details
 * Follows MediatR pattern (Query + Handler in same file)
 */

import type { IQuery, IQueryHandler, IHttpClient, BaseApiResponse } from '@/application/core';
import type { SubscriptionInfo } from './subscription.types';
import { toCamelCase } from '@/utils/caseTransform';

// ============================================================================
// Query (Request)
// ============================================================================

export class GetSubscriptionInfoQuery implements IQuery<SubscriptionInfo> {
  readonly type = 'GetSubscriptionInfoQuery' as const;
}

// ============================================================================
// Handler
// ============================================================================

export class GetSubscriptionInfoQueryHandler
  implements IQueryHandler<GetSubscriptionInfoQuery, SubscriptionInfo>
{
  constructor(private readonly httpClient: IHttpClient) {}

  async handle(_query: GetSubscriptionInfoQuery): Promise<SubscriptionInfo> {
    try {
      const response = await this.httpClient.get<BaseApiResponse<any>>(
        '/api/v1/subscription/info',
        { timeout: 60000 }
      );

      if (!response.succeeded) {
        throw new Error(response.message || 'Failed to fetch subscription info');
      }

      return toCamelCase(response.data ?? {});
    } catch (error: any) {
      if (error.response?.status === 403 || error.status === 403) {
        throw new Error('Access denied');
      }
      throw error;
    }
  }
}
